module.exports = __webpack_public_path__ + "img/measurement_info_back_upper_thigh_left.7f4096f4.jpg";